import { Loader } from '@googlemaps/js-api-loader'

export const mapLoader = new Loader({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY ?? '',
    version: 'weekly'
  })
